import { render, staticRenderFns } from "./customCheckbox.vue?vue&type=template&id=310a9654&scoped=true&"
import script from "./customCheckbox.vue?vue&type=script&lang=js&"
export * from "./customCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a9654",
  null
  
)

export default component.exports